import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {hideAppLoader, showAppLoader} from 'app/Components/Shared/Loader/LoaderSlice';
import Config from 'app/Config';
import {dwhGeneralError, dwhSuccess} from 'app/Components/Block/SimReplacementBlock/reports/dwhReports';
import {getOnboardingSubs} from 'app/Components/Page/SelfCarePage/SelfCareAsyncThunk.js';

export const getSubscribers = createAsyncThunk('SimReplacement/GetSubscribers', async (blockId, {dispatch, getState}) => {
  dispatch(showAppLoader());
  try {
    /*             const result = await ProviderManager.getProviderData('getCustomerCellularList', []);
            const subscriberList = [];
            if (result?.Body?.length == 0){
                const state = getState();
                subscriberList.push(state.authentication?.loginData?.userDetails?.contactNumber)
            }
            result.Body.forEach((sub) => subscriberList.push(sub.subscriberNo));*/
    const result = await dispatch(getOnboardingSubs());
    const subscriberList = result?.payload;
    dispatch(hideAppLoader());
    return subscriberList;
  } catch (error) {
    dispatch(hideAppLoader());
    return {
      error: true,
    };
  }
});

export const simReplacementInit = createAsyncThunk('SimReplacement/SimReplacementInit', async (request, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const state = thunkAPI.getState();
    const result = await ProviderManager.getProviderData('SimReplacementInit', [
      state.SimReplacement.blockId,
      state.SimReplacement.subscriber,
    ]);
    thunkAPI.dispatch(hideAppLoader());
    return result;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      error: true,
      reason: error,
    };
  }
});

export const simNumberAvailabilityCheck = createAsyncThunk('SimReplacement/SimNumberAvailabilityCheck', async (simNumber, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const state = thunkAPI.getState();
    const result = await ProviderManager.getProviderData('CheckSimAvailability', [Config.simActivationCodePrefix + simNumber]);
    thunkAPI.dispatch(hideAppLoader());
    return result;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      error: true,
      reason: error,
    };
  }
});

export const replaceSim = createAsyncThunk('SimReplacement/ExecuteSimReplacement', async (payload, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('ReplaceSim', [
      payload.oldSim,
      Config.simActivationCodePrefix + payload.newSim,
      payload.newSimItemId,
      payload.userBan,
      payload.userPhoneNumber,
      payload.userIdType,
      payload.userIdNumber,
      payload.todayDate,
    ]);
    thunkAPI.dispatch(hideAppLoader());
    return result;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      error: true,
      reason: error,
    };
  }
});

export const steps = {
  SubscriberSelect: 'SUBSCRIBER_SELECT',
  SimReplacement: 'SIM_REPLACEMENT',
  Error: 'ERROR',
  Init: 'INIT',
  Success: 'SUCCESS',
  OTP: 'OTP',
};

export const errors = {
  GENERAL_ERROR: 'GENERAL',
  PROCESS_ERROR: 'OPERATION_FAILED',
  UPDATE_ERROR: 'UPDATE_ERROR',
};

const initialState = {
  blockId: null,
  subscriber: null,
  simNumber: null,
  currentStep: steps.Init,
  payload: {},
  subscribers: [],
  errorReason: null,
  showPopup: false,
};

export const WHATSAPP_URL = `https://${window.location.hostname}/clm/16/21/`;
const simReplacementSlice = createSlice({
  name: 'simReplacement',
  initialState: initialState,
  reducers: {
    resetState: (state) => initialState,
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
      return state;
    },
    setPayload: (state, action) => {
      state.payload = action.payload;
      return state;
    },
    setSimNumber: (state, action) => {
      state.simNumber = state.prefixValidation ? Config.simActivationCodePrefix + action.payload : action.payload;
      return state;
    },
    setSubscribers: (state, action) => {
      state.subscriber = action.payload;
      return state;
    },
    setSubscriber: (state, action) => {
      state.subscriber = action.payload;
      state.payload.userPhoneNumber = action.payload;
      return state;
    },
    setErrorReason: (state, action) => {
      state.errorReason = action.payload;
      return state;
    },
    saveToHistory: (state, action) => {
      return state;
    },
    clearHistory: (state, action) => {
      return state;
    },
    handleSetError: (state, action) => {
      state.errorReason = action.payload?.Body?.errorDesc;
      setCurrentStep(steps.Error);
      return state;
    },
    setBlockId: (state, action) => {
      state.blockId = action.payload;
      return state;
    },
  },
  extraReducers: {
    [getSubscribers.fulfilled]: (state, action) => {
      if (!action.payload.error) {
        return {
          ...state,
          subscribers: action.payload,
          currentStep: action.payload.length > 1 ? steps.SubscriberSelect : steps.Init,
          subscriber: action.payload.length === 1 ? action.payload[0] : state.subscriber,
        };
      } else {
        return {
          ...state,
          errorReason: errors.GENERAL_ERROR,
          currentStep: steps.Error,
        };
      }
    },
    [getSubscribers.pending]: (state, action) => {
      showAppLoader();
    },
    [getSubscribers.rejected]: (state, action) => {
      state.errorReason = errors.GENERAL_ERROR;
      state.currentStep = steps.Error;
      return state;
    },
    [simReplacementInit.fulfilled]: (state, action) => {
      try {
        if (!action.payload.Body.error) {
          state.payload = action.payload.Body.userDetails;
          state.currentStep = steps.SimReplacement;
        } else {
          state.payload = action.payload?.Body?.userDetails;
          state.errorReason = action.payload?.Body?.errorDesc;
          state.errorCode = action.payload?.Body?.errorReason;
          state.currentStep = steps.Error;
        }
      } catch {
        state.errorReason = errors.GENERAL_ERROR;
        state.currentStep = steps.Error;
      }
      return state;
    },
    [replaceSim.fulfilled]: (state, action) => {
      if (action && action.payload?.Body?.isSuccess) {
        dwhSuccess(state.simNumber, state.payload.customerName, state.payload.subscriberNo, state.payload.idNumber, state.payload?.userBan);
        state.currentStep = steps.Success;
      } else {
        dwhGeneralError(
          state.simNumber,
          state.payload.customerName,
          state.payload.subscriberNo,
          state.payload.idNumber,
          state.payload?.userBan,
        );
        state.errorReason = errors.UPDATE_ERROR;
        state.currentStep = steps.Error;
      }
      return state;
    },
    [simNumberAvailabilityCheck.fulfilled]: (state, action) => {
      try {
        if (action.payload.Body.isSuccess) {
          state.payload.newSimItemId = action.payload.Body.body.response.item_id;
        }
      } catch (e) {
        console.log(e);
        state.errorReason = errors.GENERAL_ERROR;
        state.currentStep = steps.Error;
      }
      return state;
    },
    [simNumberAvailabilityCheck.rejected]: (state, action) => {
      state.errorReason = errors.GENERAL_ERROR;
      state.currentStep = steps.Error;
      return state;
    },
  },
});

export const {setSubscriber, clearHistory, saveToHistory, resetState, setCurrentStep, handleSetError, setSimNumber, setBlockId} =
  simReplacementSlice.actions;

export default simReplacementSlice.reducer;
